"use strict";

exports.Helpers = {
  isMobile: function isMobile(iPhoneOnly, excludeTablet) {
    var agentStyles;
    if (global.navigator) {
      if (iPhoneOnly) {
        agentStyles = /iPhone/i.test(global.navigator.userAgent);
      } else if (excludeTablet) {
        agentStyles = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      } else {
        agentStyles = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(global.navigator.userAgent);
      }
    }
    var isMobile = agentStyles;
    return isMobile;
  }
};